var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "scout-form",
    { attrs: { "is-modified": !!_vm.value, half: _vm.half, label: "会社ID" } },
    [
      _c("input", {
        staticClass: "boss-input",
        attrs: {
          type: "number",
          max: _vm.intMax,
          min: "0",
          "data-test": "text-box",
        },
        domProps: { value: _vm.value },
        on: {
          keypress: function ($event) {
            return _vm.onlyNumberInRange($event, _vm.intMax)
          },
          input: function ($event) {
            _vm.$emit("input", Number($event.target.value) || null)
          },
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }